import React from 'react';

export default function UserPlusIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0002 14.3333C13.3013 14.3333 15.1668 12.4678 15.1668 10.1667C15.1668 7.86548 13.3013 6 11.0002 6C8.69897 6 6.8335 7.86548 6.8335 10.1667C6.8335 12.4678 8.69897 14.3333 11.0002 14.3333Z"
        stroke="#474747"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M4.3125 18.4374C4.93949 17.2025 5.89621 16.1652 7.0766 15.4407C8.257 14.7162 9.61497 14.3326 11 14.3326C12.385 14.3326 13.743 14.7162 14.9234 15.4407C16.1038 16.1652 17.0605 17.2025 17.6875 18.4374"
        stroke="#474747"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 3.5H21"
        stroke="#474747"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 1V5.99999"
        stroke="#474747"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.875 9.42709C20.9592 9.94714 21.001 10.4732 21 11C21 12.9778 20.4135 14.9112 19.3147 16.5557C18.2159 18.2002 16.6541 19.4819 14.8268 20.2388C12.9996 20.9957 10.9889 21.1937 9.04909 20.8078C7.10929 20.422 5.32746 19.4696 3.92893 18.0711C2.53041 16.6725 1.578 14.8907 1.19215 12.9509C0.8063 11.0111 1.00433 9.00044 1.76121 7.17318C2.51808 5.34592 3.79981 3.78413 5.4443 2.68532C7.08879 1.58651 9.02218 1.00002 11 1.00002C11.5268 0.998985 12.0529 1.04079 12.5729 1.12502"
        stroke="#474747"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
